<template>
  <div class="wrapper" @click="selectOutsideEvent">
    <div class="wrap">
      <div class="wrapBg"></div>
      <leftLayout></leftLayout>
      <headerLayout></headerLayout>
      <main>
        <div class="container">
          <section class="section01">
            <div class="object01">
              {{ $t('gr101.greenTemperature') }}
            </div>
          </section>
          <section class="section02" v-show="userInfo.userRole !== 'ClubManager'" v-if="false">
            <div class="object01"></div>
            <div class="object02">
              <div class="form">
                <div class="formSelect" ref="select01">
                  <!--<div class="formSelectList" @click="openSelect01">-->
                  <div class="formSelectList">
                    <input type="text" v-model="currentClubInfo.club_name" :placeholder="$t('gr101.selectGolfClubPlaceholder')" readonly />
                  </div>
                  <div class="formSelectPopup typeSearch select01">
                    <div class="formSelectPopup-container">
                      <div class="outer">
                        <div class="inner">
                          <div class="formSelectPopup-box">
                            <div class="formSelectPopup-zone">
                              <div class="formSelectPopup-header">
                                <input type="text" :placeholder="$t('gr101.selectGolfClubPlaceholder')" v-model="searchValue" v-on:keyup="changeSearchValue" />
                              </div>
                              <ul class="formSelectPopup-body">
                                <li v-for="clubInfo in selectClubInfoList" :key="clubInfo.ccode">
                                  <label>
                                    <input type="radio" v-model="selectCcode" :value="clubInfo.ccode" v-on:change="confirmSelect01()"/>
                                    <input type="checkbox" />
                                    <i></i>
                                    <span>{{clubInfo.club_name === undefined ? '' : clubInfo.club_name}}</span>
                                  </label>
                                </li>
                              </ul>
                              <div class="formSelectPopup-footer">
                                <button class="formSelectPopup-cancel" @click="closeSelectAll()">
                                  {{ $t('common.cancel') }}
                                </button>
                                <!-- 비활성(Attribute) : disabled -->
                                <button class="formSelectPopup-confirm" @click="confirmSelect01()">
                                  {{ $t('common.confirm') }}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section class="section03">
            <!-- 기간별 그린 온도 활성(Class) : term -->
            <div class="object01">
              <div class="title">
                <ul class="list">
                  <li class="time">
                    {{ $t('gr101.hourlyGreenTemperature') }}
                  </li>
                  <li class="term" @click="moveMenu(`/GR102` + getCurrentCcodeParam())">
                    {{ $t('gr101.periodGreenTemperature') }}
                  </li>
                </ul>
              </div>
            </div>
            <div class="object02">
              <div class="formSelect" ref="select02">
                <div class="formSelectList" @click="openSelect02">
                  <input type="text" :value="$t('gr101.hourlyGreenTemperature')" readonly />
                </div>
                <div class="formSelectPopup select02">
                  <div class="formSelectPopup-container">
                    <div class="outer">
                      <div class="inner">
                        <div class="formSelectPopup-box">
                          <div class="formSelectPopup-zone">
                            <div class="formSelectPopup-header">
                              <input type="text" :placeholder="$t('gr101.selectTypePlaceholder')" />
                            </div>
                            <ul class="formSelectPopup-body">
                              <li @click="closeSelectAll">
                                <label>
                                  <input type="radio" checked/>
                                  <input type="checkbox" />
                                  <i></i>
                                  <span>{{ $t('gr101.hourlyGreenTemperature') }}</span>
                                </label>
                              </li>
                              <li @click="moveMenu(`/GR102`)">
                                <label>
                                  <input type="radio" />
                                  <input type="checkbox" />
                                  <i></i>
                                  <span>{{ $t('gr101.periodGreenTemperature') }}</span>
                                </label>
                              </li>
                            </ul>
                            <div class="formSelectPopup-footer">
                              <button class="formSelectPopup-cancel">
                                {{ $t('common.cancel') }}
                              </button>
                              <!-- 비활성(Attribute) : disabled -->
                              <button class="formSelectPopup-confirm">
                                {{ $t('common.confirm') }}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section class="section04">
            <div class="object01"></div>
            <div class="object02">
              <div class="object0201">
                <div class="item01">
                  {{ $t('gr101.lastUpdated') }}
                </div>
                <div class="item02">
                  {{updateAt}}
                </div>
                <div class="item03" @click="setData">
                  {{ $t('gr101.refresh') }}
                </div>
              </div>
            </div>
            <div class="object03">
              <div class="form">
                <div class="formSelect" ref="select03">
                  <div class="formSelectList" @click="openSelect03">
                    <input type="text" v-model="currentCourseInfo.name" :placeholder="$t('common.course')" readonly />
                  </div>
                  <div class="formSelectPopup select03">
                    <div class="formSelectPopup-container">
                      <div class="outer">
                        <div class="inner">
                          <div class="formSelectPopup-box">
                            <div class="formSelectPopup-zone">
                              <div class="formSelectPopup-header">
                                <input type="text" :placeholder="$t('gr101.selectTypePlaceholder')" />
                              </div>
                              <ul class="formSelectPopup-body">
                                <li v-for="courseInfo in courseList" :key="courseInfo.courseId">
                                  <label>
                                    <input type="radio" v-model="selectCourseId" :value="courseInfo.courseId" v-on:change="confirmSelect03()"/>
                                    <input type="checkbox" />
                                    <i></i>
                                    <span>{{courseInfo.name}}</span>
                                  </label>
                                </li>
                              </ul>
                              <div class="formSelectPopup-footer">
                                <button class="formSelectPopup-cancel">
                                  {{ $t('common.cancel') }}
                                </button>
                                <!-- 비활성(Attribute) : disabled -->
                                <button class="formSelectPopup-confirm">
                                  {{ $t('common.confirm') }}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section class="section05">
            <div class="zone">
              <div class="graph">
                <line-chart class="chart-container" v-if="chartLoaded" :chartData="chartData"></line-chart>
              </div>
              <div class="legend" v-html="legendHtml" style="display:none;"></div>
            </div>
          </section>
          <section class="section06">
            <!-- 데이터 없을때(Class) : none -->
            <div class="body" :class="valueCnt === 0 ? 'none' : ''">
              <div class="table thead">
                <!-- 헤더 고정 활성(Class) : active / x축 스크롤 이동 값(Style) : x축 스크롤 이동한 값 만큼 margin-left 마이너스 값 -->
                <div class="fixed" style="margin-left: -0px;">
                  <div class="contain">
                    <table>
                      <colgroup>
                        <col v-for="tempInfo in temperatureData" :key="tempInfo.hlidx" :class="'Hole' + viewHoleNo(tempInfo.hlidx) < 10 ? '0'+viewHoleNo(tempInfo.hlidx) : viewHoleNo(tempInfo.hlidx)">
                      </colgroup>
                      <thead>
                      <tr>
                        <th v-for="tempInfo in temperatureData" :key="tempInfo.hlidx" :class="'Hole' + viewHoleNo(tempInfo.hlidx) < 10 ? '0'+viewHoleNo(tempInfo.hlidx) : viewHoleNo(tempInfo.hlidx)">
                          <div class="item">
                            Hole {{viewHoleNo(tempInfo.hlidx)}}
                          </div>
                        </th>
                        <th v-if="valueCnt === 0">
                          <div class="item">
                            Hole
                          </div>
                        </th>
                      </tr>
                      </thead>
                    </table>
                  </div>
                </div>
              </div>
              <div class="table tbody">
                <div class="contain">
                  <table>
                    <colgroup>
                      <col :class="'hole' + holeNo < 10 ? '0'+holeNo : holeNo" v-for="holeNo in maxHoleCnt" :key="holeNo">
                    </colgroup>
                    <tbody v-if="valueCnt > 0">
                      <tr>
                        <td :class="'hole' + holeNo < 10 ? '0'+holeNo : holeNo" v-for="holeNo in maxHoleCnt" :key="holeNo">
                          <div class="item">
                            {{temperatureData.find(it => viewHoleNo(it.hlidx) === holeNo).latestTemp}}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tbody class="none">
                      <tr>
                        <td :colspan="maxHoleCnt">
                          {{ $t('gr101.noData') }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
      <footerLayout></footerLayout>
      <div class="formSelectPopup typeSearch select01">
        <div class="formSelectPopup-container">
          <div class="outer">
            <div class="inner">
              <div class="formSelectPopup-box">
                <div class="formSelectPopup-zone" ref="m_select01">
                  <div class="formSelectPopup-header">
                    <input type="text" :placeholder="$t('gr101.selectGolfClubPlaceholder')" v-model="searchValue" v-on:keyup="changeSearchValue" />
                  </div>
                  <ul class="formSelectPopup-body">
                    <li v-for="clubInfo in selectClubInfoList" :key="clubInfo.ccode">
                      <label>
                        <input type="radio" v-model="selectCcode" :value="clubInfo.ccode" v-on:change="confirmSelect01()"/>
                        <input type="checkbox" />
                        <i></i>
                        <span>{{clubInfo.club_name === undefined ? '' : clubInfo.club_name}}</span>
                      </label>
                    </li>
                  </ul>
                  <div class="formSelectPopup-footer">
                    <button class="formSelectPopup-cancel" @click="closeSelectAll()">
                      {{ $t('common.cancel') }}
                    </button>
                    <!-- 비활성(Attribute) : disabled -->
                    <button class="formSelectPopup-confirm" @click="confirmSelect01()">
                      {{ $t('common.confirm') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="formSelectPopup select02">
        <div class="formSelectPopup-container">
          <div class="outer">
            <div class="inner">
              <div class="formSelectPopup-box">
                <div class="formSelectPopup-zone" ref="m_select02">
                  <div class="formSelectPopup-header">
                    <input type="text" :placeholder="$t('gr101.selectTypePlaceholder')" />
                  </div>
                  <ul class="formSelectPopup-body">
                    <li @click="closeSelectAll">
                      <label>
                        <input type="radio" checked/>
                        <input type="checkbox" />
                        <i></i>
                        <span>{{ $t('gr101.hourlyGreenTemperature') }}</span>
                      </label>
                    </li>
                    <li @click="moveMenu(`/GR102` + getCurrentCcodeParam())">
                      <label>
                        <input type="radio" />
                        <input type="checkbox" />
                        <i></i>
                        <span>{{ $t('gr101.periodGreenTemperature') }}</span>
                      </label>
                    </li>
                  </ul>
                  <div class="formSelectPopup-footer">
                    <button class="formSelectPopup-cancel">
                      {{ $t('common.cancel') }}
                    </button>
                    <!-- 비활성(Attribute) : disabled -->
                    <button class="formSelectPopup-confirm">
                      {{ $t('common.confirm') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="formSelectPopup select03">
        <div class="formSelectPopup-container">
          <div class="outer">
            <div class="inner">
              <div class="formSelectPopup-box">
                <div class="formSelectPopup-zone" ref="m_select03">
                  <div class="formSelectPopup-header">
                    <input type="text" :placeholder="$t('gr101.selectTypePlaceholder')" />
                  </div>
                  <ul class="formSelectPopup-body">
                    <li v-for="courseInfo in courseList" :key="courseInfo.courseId">
                      <label>
                        <input type="radio" v-model="selectCourseId" :value="courseInfo.courseId" v-on:change="confirmSelect03()"/>
                        <input type="checkbox" />
                        <i></i>
                        <span>{{courseInfo.name}}</span>
                      </label>
                    </li>
                  </ul>
                  <div class="formSelectPopup-footer">
                    <button class="formSelectPopup-cancel">
                      {{ $t('common.cancel') }}
                    </button>
                    <!-- 비활성(Attribute) : disabled -->
                    <button class="formSelectPopup-confirm">
                      {{ $t('common.confirm') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* Layout */
import LeftLayout from '../layout/Left.vue'
import HeaderLayout from '../layout/Header.vue'
import FooterLayout from '../layout/Footer.vue'
import {clubInfoService, commonService, gcsService, userService} from '../../router'

import LineChart from '../../util/LineChart.js'
import Colors from 'nice-color-palettes'
import moment from 'moment'
import { formatKstToLocal, getKstMoment, getLocalMomentFromKst } from '../../util/timezone'

export default {
  name: 'GR101',
  data () {
    return {
      userInfo: {},
      updateAt: '',
      chartLoaded: false,
      maxHoleCnt: 0,
      chartData: {
        labels: [],
        datasets: []
      },
      chartSlots: [],
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            display: true,
            scaleLabel: {
              display: true,
              labelString: this.$t('gr101.chartDateAxis')
            },
            gridLines: {
              display: true // 수치마다 세로선 유무
            }
          }],
          yAxes: [{
            display: true,
            ticks: {
              suggestedMin: 0
            },
            scaleLabel: {
              display: true,
              labelString: this.$t('gr101.chartTemperatureAxis')
            }
          }]
        }
      },
      valueCnt: 0,
      legendHtml: null,
      legendItems: [],
      temperatureData: [],
      lineChart: LineChart
    }
  },
  created: function () {
    this.setDefaultChartSlots()
    userService.getAll().then(response => {
      this.userInfo = response.data
      clubInfoService.getClubInfoList('active').then(response => {
        this.clubInfoList = response.data.clubInfoList
        this.selectClubInfoList = response.data.clubInfoList
        if (this.userInfo.userRole === 'ClubManager') {
          this.currentClubCode = this.userInfo.ccode
        } else {
          if (this.$route.query.ccode === undefined) {
            this.currentClubCode = this.clubInfoList[0].ccode
          } else {
            this.currentClubCode = this.$route.query.ccode
          }
          this.setClubInfo()
        }
        this.selectCcode = this.currentClubCode
        commonService.getCourseListByCcode(this.currentClubCode).then(response => {
          this.courseList = response.data.courseList
          for (let i in this.courseList) {
            let holeCnt = this.courseList[i].endIdx - this.courseList[i].startIdx
            if (this.maxHoleCnt < holeCnt) this.maxHoleCnt = holeCnt
          }
          if (this.courseList[0] !== undefined) {
            this.currentCourseInfo = this.courseList[0]
            this.selectCourseId = this.courseList[0].courseId
          }
          this.setData()
        }).catch(error => {
          console.log('getCourseListByCcode.err.===>', error)
        })
      }).catch(error => {
        console.log('getClubInfoListByStatusActive.err.===>', error)
      })
    })
  },
  mounted: function () {
    window.addEventListener('resize', this.resizeEvt)
  },
  destroyed: function () {
    window.removeEventListener('resize', this.resizeEvt)
  },
  components: {
    LeftLayout,
    HeaderLayout,
    FooterLayout,
    LineChart
  },
  methods: {
    setData: function () {
      this.chartLoaded = false
      if (this.currentClubCode !== '' && this.currentCourseInfo.courseId !== '') {
        gcsService.getTemperatureRealTime(this.currentClubCode, this.currentCourseInfo.courseId).then(response => {
          this.temperatureData = response.data.temperatureData
          this.updateAt = this.formatKstToLocal(response.data.updateAt)
          this.setChartSlots(response.data.updateAt)
          for (let i in this.temperatureData) {
            if (this.temperatureData[i].items !== undefined) {
              if (this.temperatureData[i].items.length === 0) {
                this.temperatureData[i].latestTemp = '-'
              } else {
                this.temperatureData[i].latestTemp = this.temperatureData[i].items[this.temperatureData[i].items.length - 1].temp
                this.valueCnt += 1
              }
            }
          }
          this.setChartData()
        }).catch(error => {
          console.log('getTemperatureRealTime.err.===>', error)
        })
      }
    },
    getCurrentCcodeParam: function () {
      let currentCcode = localStorage.getItem('currentCcode')
      if (currentCcode) {
        return `?ccode=${currentCcode}`
      } else {
        return ''
      }
    },
    getCourseData: function (hlidx) {
      return this.courseList.find(it => ((it.startIdx <= hlidx) && (it.endIdx > hlidx)))
    },
    viewHoleNo: function (hlidx) {
      let startIdx = this.getCourseData(hlidx) === undefined ? 0 : this.getCourseData(hlidx).startIdx
      return (hlidx - startIdx) + 1
    },
    setChartData: function () {
      this.chartData.datasets = []
      this.chartData.labels = this.chartSlots.map(it => it.displayAt)
      for (let i in this.temperatureData) {
        if (this.temperatureData[i].items !== undefined) {
          let datasetObj = {
            spanGaps: true,
            label: 'Hole ' + this.viewHoleNo(this.temperatureData[i].hlidx),
            fill: false,
            backgroundColor: Colors[16].concat(Colors[7])[i],
            borderColor: Colors[16].concat(Colors[7])[i],
            data: []
          }
          for (let j in this.chartSlots) {
            if (this.temperatureData[i].items.find(it => it.updateAt === this.chartSlots[j].sourceAt)) {
              datasetObj.data.push(this.temperatureData[i].items.find(it => it.updateAt === this.chartSlots[j].sourceAt).temp)
            } else {
              datasetObj.data.push(null)
            }
          }
          this.chartData.datasets.push(datasetObj)
        }
      }
      this.chartLoaded = true
    },
    formatKstToLocal: formatKstToLocal,
    setDefaultChartSlots: function () {
      this.chartSlots = []
      let date = new Date().setDate(new Date().getDate() - 1)
      let fromHours = moment(date).hours()
      for (let i = 0; i < 24; i++) {
        let label = moment(date).hours(fromHours + i).format('HH:00')
        this.chartSlots.push({
          sourceAt: label,
          displayAt: label
        })
      }
      this.chartData.labels = this.chartSlots.map(it => it.displayAt)
    },
    setChartSlots: function (updateAt) {
      this.chartSlots = []
      if (!updateAt) {
        this.setDefaultChartSlots()
        return
      }
      let endAt = getKstMoment(updateAt).startOf('hour')
      if (!endAt.isValid()) {
        this.setDefaultChartSlots()
        return
      }
      for (let i = 23; i >= 0; i--) {
        let sourceAt = moment(endAt).subtract(i, 'hours')
        this.chartSlots.push({
          sourceAt: sourceAt.format('HH:00'),
          displayAt: getLocalMomentFromKst(sourceAt.format('YYYY-MM-DD HH:mm:ss')).format('HH:00')
        })
      }
    },
    confirmSelect01: function () {
      this.currentClubCode = this.selectCcode
      this.setClubInfo()
      commonService.getCourseListByCcode(this.currentClubCode).then(response => {
        this.courseList = response.data.courseList
        this.currentCourseInfo = this.courseList[0]
        this.selectCourseId = this.courseList[0].courseId
        this.setData()
      }).catch(error => {
        console.log('getCourseListByCcode.err.===>', error)
      })
      this.closeSelectAll()
    },
    confirmSelect03: function () {
      this.currentCourseInfo = this.courseList.find(it => it.courseId === this.selectCourseId)
      this.setData()
      this.closeSelectAll()
    },
    resizeEvt: function () {
      if (this.mobileFlag) {
        if (window.innerWidth > 1279) {
          this.mobileFlag = false
          this.chartLoaded = false
          this.setData()
        }
      } else {
        if (window.innerWidth < 1280) {
          this.mobileFlag = true
          this.chartLoaded = false
          this.setData()
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/gcs/GR101.vue